import { Box } from '@chakra-ui/react';
import { KText } from 'ui-library/components';
import { KBanner } from 'ui-library/components/molecules/KBanner';

export const UnDeleteCandidateBanner = ({ reason, deleted_by }) => {
  const color = 'pastel-6-dark';
  const title = 'Candidate was deleted previously';
  const description =
    'You are trying to add a candidate who was previously deleted from Kula';

  const renderChildren = () => {
    return (
      <>
        <Box>
          <KText color={color} size="sm-semi-bold">
            {title}
          </KText>
          <KText color={color}>{description}</KText>
        </Box>
        <Box pt="24px">
          <KText color={color} size="xs-semi-bold" textTransform="uppercase">
            Reason for deletion
          </KText>
          <KText wordBreak="break-word" color={color}>
            {reason}
          </KText>
        </Box>
        <Box pt="24px">
          <KText color={color} size="sm-medium">
            Deleted by {deleted_by?.name}
          </KText>
        </Box>
      </>
    );
  };
  return <KBanner status="warning" children={renderChildren()}></KBanner>;
};
